angular.module('admin')
  .config(['$stateProvider', function($stateProvider){

    const authenticated = ['SessionService', '$q', 'AuthResolver', function(SessionService, $q, AuthResolver){
      if(SessionService.isLoggedIn())
        return AuthResolver.identifyUser();
      else
        return $q.reject();
    }];

    $stateProvider.state('offices', {
      abstract: true,
      url: '/offices/:officeId',
      templateUrl: '/admin/templates/pages/offices.html',
      // note: this doesn't need auth since it's abstract;
      // the default route under it auth's for it
    });

    $stateProvider.state('offices.all', {
      url: '',
      controller: 'OfficesCtrl',
      templateUrl: '/admin/templates/pages/offices-all.html',
      resolve: {
        authenticated: authenticated
      }
    });

    $stateProvider.state('offices.stream', {
      url: '/stream',
      controller: 'OfficesStreamCtrl',
      templateUrl: '/admin/templates/pages/stream-basic.html',
      resolve: {
        authenticated: authenticated
      }
    });

  }]);
